// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-viewer-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }
  
  .image-viewer-container img {
    max-width: 90%;
    max-height: 90%;
  }

  .image-viewer-container .image-count {
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: var(--color-primaryLight);
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 16px;
  }
  
  .image-viewer-container .nav-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-primaryLight);
    font-size: 24px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;
    border-radius: 50%;
  }
  
  .image-viewer-container .close-button {
    position: absolute;
    top: 120px;
    right: 15px;
    background-color: var(--color-primaryLight);
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    font-size: 20px;
    cursor: pointer;
    z-index: 10000;
  }

  .image-viewer-container .left-arrow {
    left: 20px;
  }
  
  .image-viewer-container .right-arrow {
    right: 20px;
  }
  
  .image-viewer-checkbox-container {
    position: absolute;
    bottom: 70px;
    right: 20px;
    z-index: 1000;
  }

  .image-viewer-checkbox-container input {
    display: none;
  }
  
  .image-viewer-checkbox-container .custom-checkbox {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 3px solid var(--color-primaryLight);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    background-color: transparent;
    transition: background-color 0.2s;
  }
  
  .image-viewer-checkbox-container.selected .custom-checkbox {
    background-color: var(--color-primaryLight);
  }
  
  .image-viewer-checkbox-container.selected .custom-checkbox::before {
    color: var(--color-grey000);
  }
  
  .image-viewer-checkbox-container .custom-checkbox::before {
    content: '✓';
    font-size: 20px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0);
    transition: color 0.2s;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ImageViewer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;EACxB","sourcesContent":[".image-viewer-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 0px;\n    margin: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n  }\n  \n  .image-viewer-container img {\n    max-width: 90%;\n    max-height: 90%;\n  }\n\n  .image-viewer-container .image-count {\n    position: absolute;\n    bottom: 70px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: rgba(0, 0, 0, 0.5);\n    color: var(--color-primaryLight);\n    padding: 5px 10px;\n    border-radius: 15px;\n    font-size: 16px;\n  }\n  \n  .image-viewer-container .nav-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--color-primaryLight);\n    font-size: 24px;\n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.5);\n    padding: 10px;\n    border-radius: 50%;\n  }\n  \n  .image-viewer-container .close-button {\n    position: absolute;\n    top: 120px;\n    right: 15px;\n    background-color: var(--color-primaryLight);\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    font-size: 20px;\n    cursor: pointer;\n    z-index: 10000;\n  }\n\n  .image-viewer-container .left-arrow {\n    left: 20px;\n  }\n  \n  .image-viewer-container .right-arrow {\n    right: 20px;\n  }\n  \n  .image-viewer-checkbox-container {\n    position: absolute;\n    bottom: 70px;\n    right: 20px;\n    z-index: 1000;\n  }\n\n  .image-viewer-checkbox-container input {\n    display: none;\n  }\n  \n  .image-viewer-checkbox-container .custom-checkbox {\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    border: 3px solid var(--color-primaryLight);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    background-color: transparent;\n    transition: background-color 0.2s;\n  }\n  \n  .image-viewer-checkbox-container.selected .custom-checkbox {\n    background-color: var(--color-primaryLight);\n  }\n  \n  .image-viewer-checkbox-container.selected .custom-checkbox::before {\n    color: var(--color-grey000);\n  }\n  \n  .image-viewer-checkbox-container .custom-checkbox::before {\n    content: '✓';\n    font-size: 20px;\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0);\n    transition: color 0.2s;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
